module.exports = __webpack_public_path__ + "static/media/vis7.bb61a521.jpeg";